export default "__VITE_ASSET__DrmF7bXz__"